
export interface HistoryVarietySnapshot {
  variety: string;
  grainNature: string;
  openingStock: number;
  closingStock: number;
  purchase: number;
  sales: number;
  purchasePrice: string;
  salesPrice: string;
  purchaseSource: string;
  salesTarget: string;
  storageLocation: string;
  storageMethod: string;
  qualityGrade: string;
  moistureContent: string;
  impurityRate: string;
  unsoundKernel: string;
  storageQuality: string;
  foodSafety: string;
  settlementMethod: string;
  purchaseAmount: number;
  salesAmount: number;
  costAmount: number;
  taxAmount: number;
  subsidyAmount: number;
}

export interface HistorySubmissionRecord {
  id: string;
  date: string;
  type: string;
  period: string;
  status: '已报送' | '待报送' | '逾期';
  operator: string;
  snapshot: {
    varieties: HistoryVarietySnapshot[];
    department: string;
    totalVarieties: number;
  };
}

export const historySubmissionRecords: HistorySubmissionRecord[] = [
  {
    id: '1',
    date: '2026-01-15',
    type: '月度报送',
    period: '2025年12月',
    status: '已报送',
    operator: '管理员',
    snapshot: {
      department: '省级粮储部门',
      totalVarieties: 4,
      varieties: [
        {
          variety: '小麦',
          grainNature: '商品粮',
          openingStock: 1200,
          closingStock: 1350,
          purchase: 480,
          sales: 330,
          purchasePrice: '2,780 元/吨',
          salesPrice: '2,850 元/吨',
          purchaseSource: '张三农场（河南省周口市）；吴九粮站（河南省商丘市）',
          salesTarget: '赵六面粉厂（河南省郑州市）',
          storageLocation: '1号仓库（A区）',
          storageMethod: '散装平房仓储存',
          qualityGrade: '二等品',
          moistureContent: '12.5%',
          impurityRate: '0.8%',
          unsoundKernel: '3.2%',
          storageQuality: '宜存',
          foodSafety: '合格（真菌毒素未检出）',
          settlementMethod: '转账',
          purchaseAmount: 1334400,
          salesAmount: 940500,
          costAmount: 1334400,
          taxAmount: 28215,
          subsidyAmount: 9600,
        },
        {
          variety: '玉米',
          grainNature: '商品粮',
          openingStock: 2500,
          closingStock: 2550,
          purchase: 380,
          sales: 330,
          purchasePrice: '2,580 元/吨',
          salesPrice: '2,650 元/吨',
          purchaseSource: '楚十三合作社（河南省南阳市）',
          salesTarget: '周八饲料厂（河南省新乡市）',
          storageLocation: '2号仓库（B区）',
          storageMethod: '钢板仓机械通风储存',
          qualityGrade: '二等品',
          moistureContent: '13.0%',
          impurityRate: '1.0%',
          unsoundKernel: '4.5%',
          storageQuality: '宜存',
          foodSafety: '合格',
          settlementMethod: '现金',
          purchaseAmount: 980400,
          salesAmount: 874500,
          costAmount: 980400,
          taxAmount: 26235,
          subsidyAmount: 5700,
        },
        {
          variety: '大米',
          grainNature: '商品粮',
          openingStock: 600,
          closingStock: 520,
          purchase: 170,
          sales: 250,
          purchasePrice: '4,200 元/吨',
          salesPrice: '4,300 元/吨',
          purchaseSource: '王五合作社（河南省信阳市）',
          salesTarget: '郑十超市（河南省郑州市）',
          storageLocation: '3号仓库（C区）',
          storageMethod: '低温准低温储存',
          qualityGrade: '一等品',
          moistureContent: '14.0%',
          impurityRate: '0.5%',
          unsoundKernel: '2.8%',
          storageQuality: '宜存',
          foodSafety: '合格（重金属未超标）',
          settlementMethod: '转账',
          purchaseAmount: 714000,
          salesAmount: 1075000,
          costAmount: 714000,
          taxAmount: 32250,
          subsidyAmount: 6800,
        },
        {
          variety: '大豆',
          grainNature: '商品粮',
          openingStock: 300,
          closingStock: 280,
          purchase: 140,
          sales: 160,
          purchasePrice: '5,200 元/吨',
          salesPrice: '5,300 元/吨',
          purchaseSource: '孙七农业（河南省驻马店市）',
          salesTarget: '陈十二油脂厂（河南省漯河市）',
          storageLocation: '4号仓库（D区）',
          storageMethod: '散装平房仓储存',
          qualityGrade: '二等品',
          moistureContent: '11.5%',
          impurityRate: '0.6%',
          unsoundKernel: '2.0%',
          storageQuality: '宜存',
          foodSafety: '合格',
          settlementMethod: '承兑',
          purchaseAmount: 728000,
          salesAmount: 848000,
          costAmount: 728000,
          taxAmount: 25440,
          subsidyAmount: 0,
        },
      ],
    },
  },
  {
    id: '2',
    date: '2025-12-20',
    type: '季度报送',
    period: '2025年Q4',
    status: '已报送',
    operator: '管理员',
    snapshot: {
      department: '省级粮储部门',
      totalVarieties: 5,
      varieties: [
        {
          variety: '小麦',
          grainNature: '商品粮',
          openingStock: 1100,
          closingStock: 1200,
          purchase: 1200,
          sales: 1100,
          purchasePrice: '2,760 元/吨',
          salesPrice: '2,830 元/吨',
          purchaseSource: '张三农场；吴九粮站；李四粮行',
          salesTarget: '赵六面粉厂；魏十四面粉厂',
          storageLocation: '1号仓库（A区）',
          storageMethod: '散装平房仓储存',
          qualityGrade: '二等品',
          moistureContent: '12.8%',
          impurityRate: '0.9%',
          unsoundKernel: '3.2%',
          storageQuality: '宜存',
          foodSafety: '合格（真菌毒素未检出）',
          settlementMethod: '转账',
          purchaseAmount: 3312000,
          salesAmount: 3113000,
          costAmount: 3312000,
          taxAmount: 93390,
          subsidyAmount: 24000,
        },
        {
          variety: '玉米',
          grainNature: '商品粮',
          openingStock: 2300,
          closingStock: 2500,
          purchase: 1050,
          sales: 850,
          purchasePrice: '2,560 元/吨',
          salesPrice: '2,640 元/吨',
          purchaseSource: '楚十三合作社；河南粮贸集团',
          salesTarget: '周八饲料厂；正大饲料',
          storageLocation: '2号仓库（B区）',
          storageMethod: '钢板仓机械通风储存',
          qualityGrade: '二等品',
          moistureContent: '13.2%',
          impurityRate: '1.1%',
          unsoundKernel: '4.5%',
          storageQuality: '宜存',
          foodSafety: '合格',
          settlementMethod: '现金',
          purchaseAmount: 2688000,
          salesAmount: 2244000,
          costAmount: 2688000,
          taxAmount: 67320,
          subsidyAmount: 15750,
        },
        {
          variety: '大米',
          grainNature: '商品粮',
          openingStock: 550,
          closingStock: 600,
          purchase: 600,
          sales: 550,
          purchasePrice: '4,180 元/吨',
          salesPrice: '4,280 元/吨',
          purchaseSource: '王五合作社',
          salesTarget: '郑十超市；永辉超市',
          storageLocation: '3号仓库（C区）',
          storageMethod: '低温准低温储存',
          qualityGrade: '一等品',
          moistureContent: '14.0%',
          impurityRate: '0.5%',
          unsoundKernel: '2.8%',
          storageQuality: '宜存',
          foodSafety: '合格（重金属未超标）',
          settlementMethod: '转账',
          purchaseAmount: 2508000,
          salesAmount: 2354000,
          costAmount: 2508000,
          taxAmount: 70620,
          subsidyAmount: 18000,
        },
        {
          variety: '大豆',
          grainNature: '商品粮',
          openingStock: 280,
          closingStock: 300,
          purchase: 420,
          sales: 400,
          purchasePrice: '5,180 元/吨',
          salesPrice: '5,280 元/吨',
          purchaseSource: '孙七农业',
          salesTarget: '陈十二油脂厂',
          storageLocation: '4号仓库（D区）',
          storageMethod: '散装平房仓储存',
          qualityGrade: '二等品',
          moistureContent: '11.5%',
          impurityRate: '0.6%',
          unsoundKernel: '2.0%',
          storageQuality: '宜存',
          foodSafety: '合格',
          settlementMethod: '承兑',
          purchaseAmount: 2175600,
          salesAmount: 2112000,
          costAmount: 2175600,
          taxAmount: 63360,
          subsidyAmount: 0,
        },
        {
          variety: '高粱',
          grainNature: '商品粮',
          openingStock: 100,
          closingStock: 150,
          purchase: 200,
          sales: 150,
          purchasePrice: '3,100 元/吨',
          salesPrice: '3,200 元/吨',
          purchaseSource: '冯十一农场',
          salesTarget: '白酒酿造厂',
          storageLocation: '5号仓库（E区）',
          storageMethod: '散装平房仓储存',
          qualityGrade: '二等品',
          moistureContent: '12.0%',
          impurityRate: '0.7%',
          unsoundKernel: '3.5%',
          storageQuality: '宜存',
          foodSafety: '合格',
          settlementMethod: '转账',
          purchaseAmount: 620000,
          salesAmount: 480000,
          costAmount: 620000,
          taxAmount: 14400,
          subsidyAmount: 6000,
        },
      ],
    },
  },
  {
    id: '3',
    date: '2025-11-18',
    type: '月度报送',
    period: '2025年10月',
    status: '已报送',
    operator: '管理员',
    snapshot: {
      department: '省级粮储部门',
      totalVarieties: 3,
      varieties: [
        {
          variety: '小麦',
          grainNature: '商品粮',
          openingStock: 1050,
          closingStock: 1100,
          purchase: 350,
          sales: 300,
          purchasePrice: '2,750 元/吨',
          salesPrice: '2,820 元/吨',
          purchaseSource: '张三农场',
          salesTarget: '赵六面粉厂',
          storageLocation: '1号仓库（A区）',
          storageMethod: '散装平房仓储存',
          qualityGrade: '二等品',
          moistureContent: '12.6%',
          impurityRate: '0.8%',
          unsoundKernel: '3.2%',
          storageQuality: '宜存',
          foodSafety: '合格（真菌毒素未检出）',
          settlementMethod: '转账',
          purchaseAmount: 962500,
          salesAmount: 846000,
          costAmount: 962500,
          taxAmount: 25380,
          subsidyAmount: 7000,
        },
        {
          variety: '玉米',
          grainNature: '商品粮',
          openingStock: 2200,
          closingStock: 2300,
          purchase: 300,
          sales: 200,
          purchasePrice: '2,550 元/吨',
          salesPrice: '2,630 元/吨',
          purchaseSource: '楚十三合作社',
          salesTarget: '周八饲料厂',
          storageLocation: '2号仓库（B区）',
          storageMethod: '钢板仓机械通风储存',
          qualityGrade: '二等品',
          moistureContent: '13.1%',
          impurityRate: '1.0%',
          unsoundKernel: '4.5%',
          storageQuality: '宜存',
          foodSafety: '合格',
          settlementMethod: '现金',
          purchaseAmount: 765000,
          salesAmount: 526000,
          costAmount: 765000,
          taxAmount: 15780,
          subsidyAmount: 4500,
        },
        {
          variety: '大米',
          grainNature: '商品粮',
          openingStock: 500,
          closingStock: 550,
          purchase: 200,
          sales: 150,
          purchasePrice: '4,150 元/吨',
          salesPrice: '4,250 元/吨',
          purchaseSource: '王五合作社',
          salesTarget: '郑十超市',
          storageLocation: '3号仓库（C区）',
          storageMethod: '低温准低温储存',
          qualityGrade: '一等品',
          moistureContent: '14.0%',
          impurityRate: '0.5%',
          unsoundKernel: '2.8%',
          storageQuality: '宜存',
          foodSafety: '合格（重金属未超标）',
          settlementMethod: '转账',
          purchaseAmount: 830000,
          salesAmount: 637500,
          costAmount: 830000,
          taxAmount: 19125,
          subsidyAmount: 6000,
        },
      ],
    },
  },
  {
    id: '4',
    date: '2025-10-16',
    type: '专项报送',
    period: '秋粮收购专项',
    status: '已报送',
    operator: '管理员',
    snapshot: {
      department: '市级粮储部门',
      totalVarieties: 3,
      varieties: [
        {
          variety: '玉米',
          grainNature: '商品粮',
          openingStock: 2000,
          closingStock: 2200,
          purchase: 500,
          sales: 300,
          purchasePrice: '2,520 元/吨',
          salesPrice: '2,600 元/吨',
          purchaseSource: '楚十三合作社；秋收农户联合体',
          salesTarget: '周八饲料厂',
          storageLocation: '2号仓库（B区）',
          storageMethod: '钢板仓机械通风储存',
          qualityGrade: '二等品',
          moistureContent: '14.0%',
          impurityRate: '1.2%',
          unsoundKernel: '4.5%',
          storageQuality: '宜存',
          foodSafety: '合格',
          settlementMethod: '现金',
          purchaseAmount: 1260000,
          salesAmount: 780000,
          costAmount: 1260000,
          taxAmount: 23400,
          subsidyAmount: 10000,
        },
        {
          variety: '大豆',
          grainNature: '商品粮',
          openingStock: 250,
          closingStock: 280,
          purchase: 180,
          sales: 150,
          purchasePrice: '5,150 元/吨',
          salesPrice: '5,250 元/吨',
          purchaseSource: '孙七农业',
          salesTarget: '陈十二油脂厂',
          storageLocation: '4号仓库（D区）',
          storageMethod: '散装平房仓储存',
          qualityGrade: '二等品',
          moistureContent: '11.8%',
          impurityRate: '0.7%',
          unsoundKernel: '2.0%',
          storageQuality: '宜存',
          foodSafety: '合格',
          settlementMethod: '承兑',
          purchaseAmount: 927000,
          salesAmount: 787500,
          costAmount: 927000,
          taxAmount: 23625,
          subsidyAmount: 0,
        },
        {
          variety: '高粱',
          grainNature: '商品粮',
          openingStock: 80,
          closingStock: 100,
          purchase: 120,
          sales: 100,
          purchasePrice: '3,050 元/吨',
          salesPrice: '3,150 元/吨',
          purchaseSource: '冯十一农场',
          salesTarget: '白酒酿造厂',
          storageLocation: '5号仓库（E区）',
          storageMethod: '散装平房仓储存',
          qualityGrade: '二等品',
          moistureContent: '12.2%',
          impurityRate: '0.8%',
          unsoundKernel: '3.5%',
          storageQuality: '宜存',
          foodSafety: '合格',
          settlementMethod: '转账',
          purchaseAmount: 366000,
          salesAmount: 315000,
          costAmount: 366000,
          taxAmount: 9450,
          subsidyAmount: 3600,
        },
      ],
    },
  },
];
